import {useEffect, useId, useState} from "react";
import {useNavigate} from "react-router-dom";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {_capitalize} from "chart.js/helpers";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const StudentsCreateTicketModal = (props: { active: boolean, closeHandler: any }) => {
    const navigate = useNavigate();
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [isSuggestion,setIsSuggestion] = useState(false);
    const [ticketTitle,setTicketTitle] = useState('');
    const [message,setMessage] = useState('');
    const [err,setErr] = useState({
        title:false,
        message:false,
    });
    const ids = {
        title:useId(),
        message:useId(),
    };
    const saveTicket = () => {
        const _title = ticketTitle.trim();
        const _message = message.trim();
        const category = !isSuggestion ? '2' : '1';
        let error = {
          title:false,
          message:false,
        };
        let stop = false;
        if(_title.length < 3){
            stop = true;
            error.title = true;
        }
        if(_message.length < 3){
            stop = true;
            error.message = true;
        }
        setErr(error);
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/tickets/create',
            {
                title:_title,
                message:_message,
                category:category,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
                nd:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'تیکت جدید ایجاد گردید.',
                    'باشه',
                    5000,
                );
                document.body.classList.remove('body-no-scroll');
                navigate(`/students/tickets/view/${d.nd}`);
            },
            ()=>{
                HideProgressLoading();
            },
            AuthRedirectParents,
            'parents'
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>تیکت جدید</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>نوع تیکت را انتخاب کنید:</label>
                        <button className={"techaran-radio-box" + (isSuggestion ? ' active' : '')}
                                onClick={v => setIsSuggestion(true)}>
                            <div><i/></div>
                            <span>پیشنهادات و انتقادات</span>
                        </button>
                        <button className={"techaran-radio-box" + (!isSuggestion ? ' active' : '')}
                                onClick={v => setIsSuggestion(false)}>
                            <div><i/></div>
                            <span>پرسش و پشتیبانی</span>
                        </button>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.title}>عنوان تیکت:</label>
                        <input type="text"
                               id={ids.title}
                               className={"form-control" + (err.title ? ' is-invalid' : '')}
                               value={ticketTitle}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTicketTitle(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.title = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback " + (err.title ? 'd-block' : 'd-none')}>
                            لطفا حداقل ۳ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.message}>پیام جدید:</label>
                        <textarea
                            id={ids.message}
                            className={"form-control" + (err.message ? ' is-invalid' : '')}
                            value={message}
                            style={{minHeight: 100, maxHeight: 500}}
                            onChange={e => {
                                let t = e.currentTarget.value;
                                setMessage(t);
                                setErr(v => {
                                    let x = {...v};
                                    x.message = false;
                                    return x;
                                });
                            }}/>
                        <div className={"invalid-feedback" + (err.message ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۳ کاراکتر وارد کنید.
                        </div>
                        <div style={{marginTop: 30}}/>
                        <div className="d-flex justify-content-end align-items-center" style={{gap: 10}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveTicket}>
                                <b>ساخت تیکت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
        ;
};